import { useState } from "react";
import { Box } from "@mui/system";
import { Typography, IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

// 1. Interface voor de props definiëren
interface QuizToggleProps {
  question: string;
  defaultView: React.ReactNode;
  answerView: React.ReactNode;
}

export const QuizToggle = ({
  question,
  defaultView,
  answerView,
}: QuizToggleProps) => {
  const [showAnswer, setShowAnswer] = useState(false);

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Box sx={{ flexGrow: 1 }}>{showAnswer ? answerView : defaultView}</Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          mb: 1,
          p: 1,
          bgcolor: showAnswer ? "rgba(57, 255, 20, 0.1)" : "transparent",
          borderRadius: 1,
          border: showAnswer ? "1px solid #39ff14" : "1px solid transparent",
          transition: "all 0.3s",
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{ flexGrow: 1, fontWeight: "bold" }}
        >
          🤔 {question}
        </Typography>
        <Tooltip title={showAnswer ? "Verberg antwoord" : "Toon antwoord"}>
          <IconButton
            onClick={() => setShowAnswer(!showAnswer)}
            size="small"
            color="primary"
          >
            {showAnswer ? <VisibilityOffIcon /> : <VisibilityIcon />}
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};
